import { writable, get } from 'svelte/store';

const authStore = writable(undefined);

import Cookies from 'js-cookie';

let cachedToken = Cookies.get('token');

if(cachedToken) {
  authStore.set({
    auth: {
      access_token: cachedToken
    }
  });
}

export const authenticate = (auth) => {

  authStore.set(auth);

  Cookies.set('token', auth.auth.access_token);
}

export const logout = (auth) => {
  authStore.set(false);

  Cookies.set('token', false);


  // force a real reload of the app so all state is gone
  window.location.href = './login';
}

export const getUser = () => {
  const auth = get(authStore);
  if(!auth) {
    return false;
  }

  if(!auth.auth.access_token) {
    return false;
  }

  if(auth.auth.access_token === 'false') {
    return false;
  }

  return auth.auth.access_token;
}

export const getToken = () => {
  const auth = get(authStore);
  if(!auth) {
    return false;
  }
  return auth.auth.access_token;
}